import {CardBox} from '@hconnect/uikit/src/lib2'
import {useMediaQuery, useTheme} from '@mui/material'
import {useEffect} from 'react'

import {SystemChangeRequestContainer} from '../containers'
import {SystemsEngineerDashboardLayout} from '../layouts'

type Props = {
  plantId: string
  titleSlot?: React.ReactNode
  onEnterDashboard?: () => void
  onSystemChangeRequestClick?: (eventId: string) => void
  systemChangeRequestsLink?: string
}

export const SystemsEngineerDashboard = ({
  plantId,
  titleSlot,
  onEnterDashboard,
  onSystemChangeRequestClick,
  systemChangeRequestsLink
}: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    onEnterDashboard?.()
  }, [onEnterDashboard])

  return (
    <SystemsEngineerDashboardLayout
      titleSlot={titleSlot}
      systemChangeRequestsSlot={
        <SystemChangeRequestContainer
          plantId={plantId}
          cardBoxSx={{height: isMobile ? '70vh' : '100%'}}
          isMobile={isMobile}
          onSystemChangeRequestClick={onSystemChangeRequestClick}
          systemChangeRequestsLink={systemChangeRequestsLink}
        />
      }
      systemJobsToBeDoneSlot={<CardBox sx={{height: '100%'}}>System JTBD placeholder</CardBox>}
      systemUptimeSlot={<CardBox sx={{height: '100%'}}>System Uptime placeholder</CardBox>}
    />
  )
}
